import { applySnapshot, historyLimit } from "./lib/history";
import simulator from "@/services/simulator.js";
import gmsh from "@/services/gmsh";
import ngsolve from "@/services/ngsolve";


import Vue from 'vue';
import router from '@/router';
import { canvasToMeep } from './lib/units';
import { migrateMonitor, serializeMonitor, serializeSource } from './lib/monitors';
import updateState from './lib/updateState';
import { params2d, params3d, recordRun } from './lib/runHistory';
import { adminRun, clusterField } from '@/common/adminRun';
import { authHeaders } from '@/common/role';
import Swal from 'sweetalert2';
import {
  setCurrentGeometrySize,
  setCurrentGeometrySizeWidth,
  setCurrentGeometrySizeHeight,
  setCurrentGeometrySizeDepth,
  setCurrentGeometryRadius,
  setCurrentGeometryRotation
} from "./lib/geometryDimensions"

import {
  ZOOM,
  keyPress,
  keySolve,
} from "./lib/interfaceKeyActions"

import {
  setUserMaterials,
  setMaterialForm,
  setMaterialOfCurrentGeometry,
  resetCellMaterial,
  loadCellMaterial,
} from "./lib/materials"

import {
  setCell,
  setCoordinates,
  setPMLThickness,
  setTitle,
  setDescription,
  setResolution,
  setUntil,
  setViewSimulation,
  setSceneSimulation,
} from "./lib/cellOptions"

import {
  setCurrentGeometryPosX,
  setCurrentGeometryPosY,
  setCurrentGeometryPosZ
} from "./lib/geometryPositions"
import md5 from "js-md5";

// Histórico de edição (lib/history.js): cada item é a foto do estado ANTES de uma edição
const historyPush = (state, snapshot) => {
  state.history.past.push(snapshot);
  if (state.history.past.length > historyLimit) state.history.past.shift();
  state.history.future = [];
}

const historyUndo = (state, current) => {
  const previous = state.history.past.pop();
  if (previous === undefined) return;
  state.history.future.push(current);
  applySnapshot(state, previous);
}

const historyRedo = (state, current) => {
  const next = state.history.future.pop();
  if (next === undefined) return;
  state.history.past.push(current);
  applySnapshot(state, next);
}

const historyReset = (state) => {
  state.history = { past: [], future: [] };
}

const setNotice = (state, { text, undo = false }) => {
  state.notice = { id: state.notice.id + 1, text, undo };
}

// Opções do Meep guardadas no nível da simulação (boundary, decayThreshold)
const setSimulationOption = (state, [field, value]) => {
  state[field] = value;
}

const GeometryListAppend = (state, geometry) => {
  state.GeometryList.push(geometry)
}

const setCurrentGeometryFillPattern = (state, geometryData) => {
  try {
    state.GeometryList.forEach((e) => {
      if (e.token == state.selectedToken) {
        e.geometricFillPattern.push(geometryData);
      }
    });
  } catch (err) {
    return { message: err.message }
  }

}

const setCurrentViewMode = (state, content) => {
  state.viewMode = content
}

const SourcesListAppend = (state, source) => {
  state.SourcesList.push(source)
}

const FluxListAppend = (state, flux) => {
  state.FluxList.push(flux)
}

const GeometryListRemove = (state, geometry) => {
  state.FluxList.forEach((content, indice) => {
    if (content.token == geometry) {
      state.FluxList.splice(indice, 1)
    }
  });
  state.SourcesList.forEach((content, indice) => {
    if (content.token == geometry) {
      state.SourcesList.splice(indice, 1)
    }
  });
  state.GeometryList.forEach((content, indice) => {
    if (content.token == geometry) {
      state.GeometryList.splice(indice, 1)
    }
  });
}

const removeGeometricItem = (state, indexToRemove) => {
  state.GeometryList.forEach((content) => {
    if (content.token == state.selectedToken) {
      content.geometricFillPattern.splice(indexToRemove, 1);
    }
  });
}

const setGeometryList = (state, newList) => {
  state.GeometryList = newList;
}

const setGeometricFillPatternList = (state, newList) => {
  state.currentGeometry.geometricFillPattern = newList;
}

const setSourcesList = (state, newList) => {
  state.SourcesList = newList;
}

const setFluxList = (state, newList) => {
  state.FluxList = newList;
}

const setDrawingStatus = (state, status) => {
  state.drawing = status;
}

const setKonvaStage = (state, konvaStageObject) => {
  state.konvaStage = konvaStageObject;
}

const setCurrentKonvaStageLayers = (state, konvaStageObject) => {
  state.konvaStage.children[0] = konvaStageObject;
}

const setSelectedToken = (state, token) => {
  state.selectedToken = token;
}

const setSelectedShapeName = (state, shape) => {
  state.selectedShapeName = shape;
}

const setCurrentScale = (state, scale) => {
  state.currentScale = scale;
}

const setStageSize = (state, { width, height }) => {
  state.configKonva.width = width;
  state.configKonva.height = height;
}

const setZoomAction = (state, action_string) => {
  state.zoomAction = action_string;
}

const setCurrentGeometry = (state, geometry) => {
  state.currentGeometry = geometry;
}

const setCurrentMode = (state, string) => {
  state.mode = string;
  state.configKonva.draggable = (state.mode == 'handOn') ? true : false;
}

const setShapeOfCurrentGeometry = (state, data) => {
  state.shape = data;
}

const updateColor = (state, data) => {
  state.color = data;
}

const dismiss = (state) => {
  state.modalView = "nenhum";
}

const openModal = (state, string) => {
  state.modalView = string;
}

const showCompleteModal = (state, boolean_choice) => {
  state.ShowModalComplete = boolean_choice;
}

const setCurrentGeometryData = (state, geometryData) => {
  try {
    state.GeometryList.forEach((e) => {
      if (e.token == state.selectedToken) {
        e = geometryData;
      }
    });
  } catch (err) {
    return { message: err.message }
  }
}


const setCurrentGeometryWaveLength = (state, geometryData) => {
  try {
    state.SourcesList.forEach((e) => {
      if (e.token == state.selectedToken) {
        e.waveLength = geometryData;
      }
    });
  } catch (err) {
    return { message: err.message }
  }
}

const setCurrentGeometryWaveWidth = (state, geometryData) => {
  try {
    state.SourcesList.forEach((e) => {
      if (e.token == state.selectedToken) {
        e.waveWidth = geometryData;
      }
    });
  } catch (err) {
    return { message: err.message }
  }
}



const setCurrentGeometryWaveSize = (state, geometryData) => {
  try {
    state.SourcesList.forEach((e) => {
      if (e.token == state.selectedToken) {
        e.waveSize = geometryData;
      }
    });
  } catch (err) {
    return { message: err.message }
  }
}

const setCurrentGeometryFrequency = (state, geometryData) => {
  try {
    state.SourcesList.forEach((e) => {
      if (e.token == state.selectedToken) {
        e.frequency = geometryData;
      }
    });
  } catch (err) {
    return { message: err.message }
  }
}

const setCurrentGeometryIntegrated = (state, geometryData) => {
  try {
    state.SourcesList.forEach((e) => {
      if (e.token == state.selectedToken) {
        e.integrated = geometryData;
      }
    });
  } catch (err) {
    return { message: err.message }
  }
}


const setSelectedSourceToken = (state, content) => {
  state.selectedSourceToken = content;
}


const setLoadingSimulation = (state, content) => {
  state.loading_simulation = content;
}

const updateSizeAndPosition = (state, content) => {
  var {
    x,
    y,
    z
  } = content;
  setCurrentGeometryPosX(((x + (state.coordinates.x / 2)) * state.dimensions.relationship.x) - (state.currentGeometry.width / 2));
  setCurrentGeometryPosY((((state.coordinates.y / 2) + y) * state.dimensions.relationship.y) - (state.currentGeometry.height / 2));
  setCurrentGeometryPosZ((((state.coordinates.z / 2) + z) * state.dimensions.relationship.z) - (state.currentGeometry.depth / 2));
}

const openPlotOptions = (state, content) => {
  state.showPlotOptions = content;
}

const set_generateAxis = (state, content) => {
  state.plotOptions.generateAxis = (content) ? 1 : 0;
}
const set_generateVideo = (state, content) => {
  state.plotOptions.generateVideo = (content) ? 1 : 0;
}
const set_generateDielectric = (state, content) => {
  state.plotOptions.generateDielectric = (content) ? 1 : 0;
}
// Componente do campo desenhado no mapa, na prévia e no vídeo (o Meep aceita Ex..Hz)
const FIELD_COMPONENTS = ["Ex", "Ey", "Ez", "Hx", "Hy", "Hz"];
const set_plotAxis = (state, content) => {
  state.plotOptions.plotAxis = FIELD_COMPONENTS.includes(content) ? content : "Ez";
}
const set_realtime = (state, content) => {
  state.plotOptions.realtime = (content) ? 1 : 0;
}

const set_labels = (state, content) => {
  state.plotOptions.labels = (content) ? 1 : 0;
}

const set_field_parameters = (state, content) => {
  state.plotOptions.field_parameters[content[0]] = content[1];
}

const set_monitor_parameters = (state, content) => {
  state.plotOptions.monitor_parameters = content;
}


const set_source_parameters = (state, content) => {
  state.plotOptions.source_parameters = content;
}

const set_plotViews = (state, content) => {
  state.plotOptions.plotViews = content;
}

const set_boundary_parameters = (state, content) => {
  state.plotOptions.boundary_parameters = content;
}

const set_eps_parameters = (state, content) => {
  state.plotOptions.eps_parameters = content;
}

const set_plotOptions = (state, content) => {
  state.plotOptions[content[0]][content[1]] = content[2];
}

const set_showMiniCanvas = (state, content) => {
  state.mode = "miniCanvas";
  state.showMiniCanvas = content;
}

const setSelectedInsideToken = (state, content) => {
  state.selectedInsideToken = content;
}

const setPropertiesGeometryFill = (state, content) => {
  state.GeometryList.forEach((e) => {
    if (e.token == state.selectedToken) {
      e.geometricFill.properties[content[0]] = content[1];
    }
  });
}

// Altera um campo do objeto selecionado (geometria, fonte ou monitor): [campo, valor] ou [campo, subcampo, valor].
// Vue.set porque itens salvos antes podem não ter o campo (atribuição direta não seria reativa).
const updateGeometry = (state, content) => {
  [...state.GeometryList, ...state.FluxList, ...state.SourcesList].forEach((e) => {
    if (e.token == state.selectedToken) {
      if (content.length == 2) {
        Vue.set(e, content[0], content[1]);
      } else if (content.length === 3) {
        Vue.set(e[content[0]], content[1], content[2]);
      }
    }
  });
}


const setCurrentGeometricElementMiniCanvas = (state, content) => {
  try {
    let padraoGeometria = state.GeometryList.filter((e) => e.token == state.selectedToken);
    padraoGeometria[0].geometricFillPattern.forEach(e => {
      if (e.token == content[0]) {
        e[content[1]] = content[2];
      }
    });
  } catch (err) {
    Swal.fire({ title: 'An Error Appears!', text: err.message })
  }
}

const set3dState = (state, { data }) => {
  try {
    // Abrir uma simulação não pode reabrir o aviso "simulação concluída" de uma execução anterior
    state.view_simulation = false;
    state.loading_simulation = false;
    // No 3D um clique no canvas com a ferramenta "criar" insere uma peça: abre sempre na seleção
    state.mode = "transform";
    state.is3d = true,
    state.GeometryList = [...data.geometries];
    state.SourcesList = [...data.sources];
    state.title = data.title;
    state.description = data.description;
    state.scene_design = data.scene_design;
    state.scene_simulation = data.scene_simulation;
    state.movie = data.movie;
    state.id = data._id;
    state.author = data.author;
    state.productions = data.productions;
    state.quality3d = data.quality || "accurate";
  } catch (err) {
    Swal.fire({
      title: 'An error appears ns!',
      text: err.message
    });
    console.error(err.message);
    router.push('/dashboard');
  }
}

// Geometrias sem os campos de preenchimento (dados antigos ou importados) derrubavam o canvas 2D,
// que lê geometricFill.properties de cada uma
const withFillDefaults = (geometry) => ({
  ...geometry,
  geometricFill: geometry.geometricFill && geometry.geometricFill.properties
    ? geometry.geometricFill
    : { properties: { name: `Default ${geometry.name || ""}`, width: 1, height: 1, image: "" }, elements: [] },
  geometricFillPattern: geometry.geometricFillPattern || []
});

const setState = (state, { data }) => {
  try {
    state.view_simulation = false;
    state.loading_simulation = false;
    state.is3d = false;
    state.GeometryList = (data.geometries || []).map(withFillDefaults);
    state.FluxList = (data.flux || []).map(migrateMonitor);
    state.SourcesList = [...data.sources];
    state.title = data.title;
    state.description = data.description;
    state.scene_design = data.scene_design;
    state.scene_simulation = data.scene_simulation;
    state.movie = data.movie;
    state.id = data._id;
    state.author = data.author;
    state.productions = data.productions;
    state.coordinates = data.coordinates;
    state.resolution = data.resolution;
    state.charts = data.charts;
    state.plotOptions = data.plotOptions;
    state.pml = { thickness: Number((data.pml && data.pml.thickness) || 1) };
    state.until = Number(data.until) || Number(data.plotOptions && data.plotOptions.until) || state.until;
    if (state.plotOptions) state.plotOptions.until = state.until;
    state.boundary = data.boundary || "pml";
    state.decayThreshold = Number(data.decayThreshold) || 1e-3;
    // Sem isso o material de fundo da simulação aberta antes continuava no store
    loadCellMaterial(state, data);
    setCoordinates(state, data.coordinates);
  } catch (err) {
    Swal.fire({
      title: 'An error appears ns2!',
      text: err.message
    });
    console.error(err.message);
    router.push('/dashboard');
  }
}

// Rotação do Konva (graus, sentido horário na tela) aplicada a um deslocamento local
const rotateOffset = (dx, dy, rotation) => {
  const angle = (rotation || 0) * Math.PI / 180;
  return [
    dx * Math.cos(angle) - dy * Math.sin(angle),
    dx * Math.sin(angle) + dy * Math.cos(angle)
  ];
}

// Cada forma do Konva usa uma origem diferente:
//  - block (Rect): x,y é o canto superior esquerdo e a rotação é em torno dele
//  - sphere (Circle) e triangle (RegularPolygon): x,y é o centro e o tamanho é o raio
const reclassficateGeometries = (state, conteudo) => {
  const { relationship } = state.dimensions;
  const x = Number(conteudo.x) || 0;
  const y = Number(conteudo.y) || 0;
  const rotation = Number(conteudo.rotation) || 0;
  let position;
  let size;
  let vertices;

  if (conteudo.shape == "sphere" || conteudo.shape == "triangle") {
    const radius = Math.abs(Number(conteudo.radius) || 0);
    position = canvasToMeep(state, x, y);
    size = [radius / relationship.x, radius / relationship.y];

    if (conteudo.shape == "triangle") {
      // Mesmos vértices que o Konva desenha: o primeiro aponta para cima
      const sides = conteudo.sides || 3;
      vertices = [];
      for (let i = 0; i < sides; i++) {
        const angle = (2 * Math.PI * i) / sides;
        const [dx, dy] = rotateOffset(radius * Math.sin(angle), -radius * Math.cos(angle), rotation);
        vertices.push(canvasToMeep(state, x + dx, y + dy));
      }
    }
  } else {
    const width = Number(conteudo.width) || 0;
    const height = Number(conteudo.height) || 0;
    const [dx, dy] = rotateOffset(width / 2, height / 2, rotation);
    position = canvasToMeep(state, x + dx, y + dy);
    size = [Math.abs(width) / relationship.x, Math.abs(height) / relationship.y];
  }

  return { ...conteudo, position, size, vertices, fill: conteudo.fill || '#FF0000' };
}

// Também usada nas páginas de resultado para mostrar as geometrias em µm
export { reclassficateGeometries as geometryToMeep };

const fireErrorAlert = (message) => {
  Swal.fire({
    title: 'An error appears ns3!',
    text: message
  });
}
// Payload de /meep/exec a partir do que está desenhado (também usado no comparativo de latência)
export function build2dPayload(state) {
  const {
    title,
    author,
    resolution,
    description,
    default_material,
    until,
    pml,
    boundary,
    decayThreshold,
    GeometryList,
    SourcesList,
    FluxList,
    coordinates,
    plotOptions,
    generateVideo,
    id
  } = state;
  var geometries = GeometryList.map((geometry) => reclassficateGeometries(state, geometry));
  // Fontes e monitores em µm (sem alterar os objetos do canvas, que ficam em pixels)
  var sources = SourcesList.map((source) => serializeSource(state, source));
  var flux = FluxList.map((monitor) => serializeMonitor(state, monitor));
  return {
      title,
      author,
      "simulation": id,
      resolution: Number(resolution),
      description,
      flux,
      default_material,
      until,
      pml,
      boundary,
      decayThreshold,
      geometries,
      sources,
      coordinates,
      plotOptions,
      generateVideo
  };
}

const runSimulation = async (state) => {
  state.sincronizado = false;
  state.loading_simulation = true;
  // A janela de opções fecha: a de carregamento (com a prévia) fica sozinha na tela
  state.showPlotOptions = false;
  // Identifica esta execução nos arquivos da prévia em tempo real (live.json do módulo 2D)
  state.liveId = `${Date.now()}`;
  const payload = { ...build2dPayload(state), liveId: state.liveId };
  // Teste de administrador: máquinas escolhidas à mão (o servidor confere o login)
  const cluster = clusterField(adminRun.override);
  const headers = cluster ? await authHeaders() : {};
  if (cluster) payload.cluster = cluster;
  // Dashboard do perfil: tempo visto pelo usuário e resumo da execução devolvido pela API
  const startedAt = Date.now();
  let run;
  let recorded = false;

  simulator
    .post("/exec", payload, { headers }).then(function ({ data: response }) {
      const { error } = response;
      let { data } = response;
      run = response.run;
      if (error) {
        throw new Error(data.replace('meep:', ' '));
      }

      data = JSON.parse(data);
      state.charts = [];
      state.scene_design = data.scene;
      state.scene_simulation = data.wave_scene;
      state.movie = data.videoName;


      state.charts.push({
        title: 'Dieletrico',
        type: 'graphic',
        content: data.scene
      });

      state.charts.push({
        title: 'Simulação Gerada',
        type: 'graphic',
        content: data.wave_scene
      });

      // Só existe quando a opção "Video" está marcada nas opções de plot
      if (data.videoName) {
        state.charts.push({
          title: 'Vídeo',
          type: 'movie',
          content: data.videoName
        });
      }

      // Um gráfico por monitor (arquivo JSON com T ou R por frequência)
      (data.fluxes || []).forEach((file, index) => {
        state.charts.push({
          title: `Spectrum ${index + 1}`,
          type: 'flux',
          content: file
        });
      });

      // Ressonâncias do Harminv: os modos vêm direto na resposta
      (data.resonances || []).forEach((resonance) => {
        state.charts.push({
          title: resonance.name,
          type: 'resonance',
          content: resonance
        });
      });

      var str = state;
      delete str._id;

      state.productions.push({ content: JSON.stringify(str) });

      state.view_simulation = true;
      state.loading_simulation = false;
      recordRun({ state, kind: "2d", startedAt, status: "completed", run, params: params2d(state) });
      recorded = true;

    }).then(() => {
      updateState(state);
    })
    .catch((err) => {
      // Resposta com erro do solver ou falha de rede (sem resposta: run fica indefinido)
      const response = err.response && err.response.data;
      if (!recorded) {
        recordRun({ state, kind: "2d", startedAt, status: "failed", error: err.message,
          run: run || (response && response.run), params: params2d(state) });
      }
      fireErrorAlert(err.message);
      state.loading_simulation = false;
      state.showPlotOptions = false
    });
}

// Entradas do Gmsh e do NGSolve a partir do que está desenhado (também usado no comparativo)
export function build3dInputs(state) {
  const { GeometryList, SourcesList, quality3d } = state;
  // O Gmsh e o NGSolve precisam do mesmo preset (tamanho da malha e ordem dos elementos)
  const quality = quality3d || "accurate";
  // O Gmsh espera o raio para a esfera e largura/altura/profundidade para as demais formas
  const geometryList = GeometryList.map(geometry => {
    const { shape, width, height, depth, radius, x, y, z } = geometry;
    const base = {
      shape,
      material: geometry.materialTitle || "default",
      epsilon: Number(geometry.epsilon) || 1,
      x: Number(x),
      y: Number(y),
      z: Number(z)
    };

    if (shape == "sphere") return { ...base, radius: Math.abs(Number(radius)) };
    return {
      ...base,
      width: Math.abs(Number(width)),
      height: Math.abs(Number(height)),
      depth: Math.abs(Number(depth))
    };
  });

  // Comprimento de onda e largura (desvio padrão da gaussiana) configurados em cada fonte, em µm
  const sources = SourcesList.map(source => ({
    wavelength: Number(source.waveLength) > 0 ? Number(source.waveLength) : 1.55,
    wave_width: Number(source.waveWidth) > 0 ? Number(source.waveWidth) : 0.4,
    source_position: [Number(source.x), Number(source.y), Number(source.z)]
  }));
  return { geometryList, sources, quality };
}

const run3dSimulation = async (state) => {
  state.sincronizado = false;
  state.loading_simulation = true;
  state.showPlotOptions = false;

  const { GeometryList, id, SourcesList, productions } = state;
  const { geometryList, sources, quality } = build3dInputs(state);
  // Teste de administrador: lido já aqui, porque a janela de opções (que guarda a escolha) fecha agora
  const cluster = clusterField(adminRun.override);
  const startedAt = Date.now();
  let mesh;
  try {
    if (!geometryList.length) throw new Error("Add at least one geometry before running the simulation.");
    if (!sources.length) throw new Error("Add at least one source before running the simulation.");

    // A malha cobre geometrias e fontes; cada geometria vira o grupo físico "geo<N>"
    ({ data: mesh } = await gmsh.post("/", { id, geometries: geometryList, sources, quality }));

    const production = md5.hex(Date.now().toString());
    const productionData = { 
      GeometryList,
      SourcesList,
      quality,
      content: production
    }
    const ngsolveRequestData = {
      title: state.title,
      author: state.author,
      simulation_id: id,
      production: production,
      gmsh_mesh_path: id+".msh",
      materials: mesh.materials.map(({ name, epsilon }) => ({ name, eps_r: epsilon })),
      sources,
      quality
    }
    // Teste de administrador: máquinas escolhidas à mão (o servidor confere o login)
    if (cluster) ngsolveRequestData.cluster = cluster;
    const headers = cluster ? await authHeaders() : {};

    const { data: solved } = await ngsolve.post("/simulate", ngsolveRequestData, { headers });
    recordRun({ state, kind: "3d", startedAt, status: "completed", production, run: solved && solved.run,
      params: params3d(state, quality, mesh) });
    // Só registra a produção depois que o NGSolve gerou os resultados
    productions.push(productionData);
    state.loading_simulation = false;
    updateState(state);
    router.push(`/datails3d/${state.id}/${production}/`);

  } catch (err) {
    // Gmsh e NGSolve (FastAPI) devolvem o motivo em response.data.detail
    const detail = err.response && err.response.data && err.response.data.detail;
    const message = typeof detail === "string" ? detail : detail ? JSON.stringify(detail) : err.message;
    recordRun({ state, kind: "3d", startedAt, status: "failed", error: message, params: params3d(state, quality, mesh) });
    fireErrorAlert(message);
    state.loading_simulation = false;
    state.showPlotOptions = false
  }
}

const clearCanvas = (state) => {
  state.GeometryList = [];
  state.FluxList = [];
  state.SourcesList = [];
}

const setAuthor = (state, content) => {
  state.author = content;
}

const setShowModalSettingsFlux = (state, content) => {
  state.showModalSettingsFlux = content;
}

const closeErrorModal = (state, content) => {
  state.showError = content;
  state.errorMessage = "";
}



export {
  setSimulationOption,
  historyPush,
  historyUndo,
  historyRedo,
  historyReset,
  setNotice,
  GeometryListAppend,
  setDrawingStatus,
  setSelectedToken,
  setSelectedShapeName,
  setCurrentGeometry,
  setShapeOfCurrentGeometry,
  setCurrentMode,
  setZoomAction,
  setCurrentScale,
  setStageSize,
  setKonvaStage,
  setCurrentGeometryData,
  ZOOM,
  keyPress,
  keySolve,
  updateColor,
  dismiss,
  openModal,
  showCompleteModal,
  setCurrentKonvaStageLayers,
  setGeometryList,
  GeometryListRemove,
  setCurrentGeometrySize,
  setCurrentGeometrySizeWidth,
  setCurrentGeometrySizeHeight,
  setCurrentGeometrySizeDepth,
  setCurrentGeometryPosX,
  setCurrentGeometryPosY,
  setCurrentGeometryPosZ,
  setCurrentGeometryRadius,
  setMaterialForm,
  setUserMaterials,
  setMaterialOfCurrentGeometry,
  resetCellMaterial,
  setSourcesList,
  SourcesListAppend,
  setCurrentViewMode,
  setSelectedSourceToken,
  setCurrentGeometryWaveLength,
  setCurrentGeometryWaveWidth,
  setCurrentGeometryWaveSize,
  setCurrentGeometryFrequency,
  setViewSimulation,
  setSceneSimulation,
  setLoadingSimulation,
  setCurrentGeometryIntegrated,
  setPMLThickness,
  setTitle,
  setDescription,
  setResolution,
  setUntil,
  setCoordinates,
  setCell,
  updateSizeAndPosition,
  openPlotOptions,
  set_generateAxis,
  set_generateVideo,
  set_generateDielectric,
  set_plotAxis,
  set_realtime,
  set_labels,
  set_field_parameters,
  set_monitor_parameters,
  set_source_parameters,
  set_plotViews,
  set_boundary_parameters,
  set_eps_parameters,
  set_plotOptions,
  FluxListAppend,
  setFluxList,
  set_showMiniCanvas,
  setCurrentGeometryFillPattern,
  setGeometricFillPatternList,
  removeGeometricItem,
  setSelectedInsideToken,
  setPropertiesGeometryFill,
  setCurrentGeometricElementMiniCanvas,
  set3dState,
  setState,
  updateState,
  runSimulation,
  run3dSimulation,
  clearCanvas,
  setAuthor,
  setShowModalSettingsFlux,
  updateGeometry,
  closeErrorModal,
  setCurrentGeometryRotation
}
